export default "__VITE_ASSET__Cv83mWPA__ 100w";